import BinarySocket from '_common/base/socket_base';
import { setWebsocket } from '@deriv/shared';

const WS = BinarySocket;

// PR-RT.1.1: wire the shared `WS` export so `import { WS } from '@deriv/shared'`
// returns the real BinarySocket. Without this, the shared `let WS` defined in
// `@deriv/shared/services/ws-methods.ts` stays `undefined` forever — nobody
// else calls setWebsocket() — and any consumer that imports WS from shared
// (notably `packages/bot-skeleton/src/services/api/public-ws-shim.js` after
// PR-RT.1) silently no-ops every call into WS.xxx().
//
// Live ES6 binding semantics: shared/ws-methods.ts exports `let WS`, so this
// assignment propagates to every importer that reads the binding lazily (i.e.
// at function-call time, not at import time). The shim does exactly that.
setWebsocket(WS);

export default WS;
